import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UserListPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://installmentzone.com/api";

  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);

      const apiUrl = `${API_BASE_URL}/admin_panel/v1/users/users.php`;

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const result = await response.json();
      if (result && result.success && Array.isArray(result.data)) {
        setUsers(result.data);
        if (result.data.length > 0) {
          toast.info(`${result.data.length} users loaded.`);
        }
      } else {
        throw new Error(result.error || "Unexpected API response structure.");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching users.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      const apiUrl = `${API_BASE_URL}/admin_panel/v1/users/delete.php`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: userId }),
      });

      const result = await response.json();
      if (result && result.success) {
        setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
        toast.success("User deleted successfully.");
      } else {
        throw new Error(result.error || "Failed to delete user.");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred while deleting the user.");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  if (loading)
    return <p style={{ color: "#fff", textAlign: "center" }}>Loading users...</p>;

  if (error)
    return (
      <div
        style={{
          padding: "20px",
          margin: "20px auto",
          background: "rgba(255, 255, 255, 0.1)",
          border: "1px solid red",
          borderRadius: "10px",
          maxWidth: "800px",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <h3 style={{ color: "#F87171" }}>Error Fetching Users</h3>
        <p>{error}</p>
        <button
          onClick={fetchUsers}
          style={{
            padding: "10px 20px",
            marginTop: "10px",
            background: "#1E3A8A",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Retry
        </button>
      </div>
    );

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
        fontFamily: "Segoe UI, sans-serif",
        color: "#fff",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        scrollBehavior: "smooth",
      }}
    >
      <ToastContainer />
      <div
        style={{
          background: "rgba(255, 255, 255, 0.15)",
          padding: "30px",
          borderRadius: "15px",
          maxWidth: "1000px",
          margin: "0 auto",
          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
          backdropFilter: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h2>User Management</h2>
          <Link to="/users/create">
            <button
              style={{
                padding: "10px 15px",
                background: "#F97316",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              Add New User
            </button>
          </Link>
        </div>

        {users.length === 0 ? (
          <p style={{ textAlign: "center" }}>No users found.</p>
        ) : (
          <div style={{ overflowX: "auto", willChange: "transform" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                background: "rgba(255, 255, 255, 0.9)",
                borderRadius: "10px",
                overflow: "hidden",
                color: "#1E293B",
                tableLayout: "fixed",
              }}
            >
              <thead>
                <tr style={{ background: "#1E3A8A", color: "#fff" }}>
                  <th style={{ padding: "14px", textAlign: "left" }}>ID</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Name</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Email</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Role</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, index) => (
                  <tr
                    key={user.id}
                    style={{
                      background: index % 2 === 0 ? "#F8FAFC" : "#FFFFFF",
                      borderBottom: "1px solid #E5E7EB",
                      transition: "background 0.2s ease",
                    }}
                  >
                    <td style={{ padding: "12px" }}>{user.id}</td>
                    <td style={{ padding: "12px" }}>{user.name}</td>
                    <td style={{ padding: "12px" }}>{user.email}</td>
                    <td style={{ padding: "12px" }}>{user.role}</td>
                    <td style={{ padding: "12px" }}>
                      <Link
                        to={`/users/edit/${user.id}`}
                        state={{ user }} // <-- pass the full user object
                        style={{
                          marginRight: "10px",
                          color: "#F97316",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => handleDelete(user.id)}
                        style={{
                          color: "#fff",
                          background: "#DC2626",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserListPage;
